import { z } from 'zod'

/**
 * Ticket-level Consequence of Failure editor inside a ConditionalForm step.
 * Writes the `consequence_of_failure` field the NII Zones coverage math reads.
 */
export const ConsequenceOfFailureSectionSchema = z.object({
  id: z.string(),
  type: z.literal('consequence_of_failure'),
  title: z.string().optional(),
  /** Opaque to Forecast — read by gong-agent-service via the workflow config. */
  agent: z.record(z.string(), z.unknown()).optional(),
  /** Gecko Internal users also have access regardless of this permission list. */
  agentPermissions: z.array(z.string()).optional(),
})

export type ConsequenceOfFailureSection = z.infer<
  typeof ConsequenceOfFailureSectionSchema
>
